import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { useLoadDeploymentsCurrent } from "Reducers/environment/deployment/hooks";

type CurrentServiceDecodedParams = {
  environmentId: string;
  organizationId: string;
  projectId: string;
  appName: string;
};

export const useCurrentWorker = () => {
  const {
    environmentId,
    organizationId,
    projectId,
    appName = "routes"
  } = useDecodedParams<CurrentServiceDecodedParams>();

  const environment = useSelectorWithUrlParams(environmentSelector, {
    environmentId
  });
  const { currentDeployment } = useLoadDeploymentsCurrent(
    { organizationId, projectId, environmentId },
    !!environment?.has_code
  );

  const workers = currentDeployment?.workers || {};
  const currentWorker = workers[appName];
  const prefix = `${currentWorker?.app}--`;

  if (currentWorker) {
    Object.assign(currentWorker, {
      displayName: currentWorker.name.replace(prefix, "")
    });
  }

  return currentWorker;
};
